import {request} from '@/utils/request'
import API from '@/constants/apis'
import * as types from './mutation-types'

export const performInit = ({
  commit
}, {performId}) => {
  return request(API.PERFORM_INIT_API, 'GET', {
    performId
  }).then(res => {
    console.log(res)
    if (res && res.success) {
      commit(types.PERFORM_INIT, res)
    }
    if (res.sessions.length) {
      commit(types.SET_CURRENT_SESSIONS, res.sessions[0])
      commit(types.SET_CURRENT_PRICE_LIST, res.sessions[0].prices)
      commit(types.SET_CURRENT_PRICE, res.sessions[0].prices[0])
    }

    let groupdSessionKeys = Object.keys(res.groupedSessions)

    if (groupdSessionKeys.length) {
      // 只需要存KEY
      let obj = {id: groupdSessionKeys[0]}
      commit(types.SET_CURRENT_GROUP, obj)
      commit(types.SET_CURRENT_SESSIONS, res.groupedSessions[groupdSessionKeys[0]][0])
      commit(types.SET_CURRENT_PRICE_LIST, res.groupedSessions[groupdSessionKeys[0]][0].prices)
    } else {
      console.log('no grouped sessions')
    }
    return res
  })
}
export const getActorDetail = ({
  commit
}, {actorId}) => {
  return request(API.GET_ACTOR_DETAIL(actorId), 'GET', {}).then(res => {
    if (res && res.success) {
      commit(types.SET_CURRENT_ACTOR, res)
    }
    return res
  })
}



// WEBPACK FOOTER //
// ./src/store/theatreabove/actions.js